const stripTags = (str: string = '') => str.replace(/<[^>]+>/g, '');

export default stripTags;
